import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bca51d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 1,
  class: "flex"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_4 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_5 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_6 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "mt-3 sm:mt-4" }
const _hoisted_10 = {
  key: 1,
  class: "relative isolate flex flex-col flex-wrap justify-around items-center overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30",
    style: {"clip-path":"polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)"}
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30",
    style: {"clip-path":"polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)"}
  })
], -1))
const _hoisted_13 = { class: "text-sm leading-6 text-gray-900 text-center flex" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "text-center p-2 text-xl" }
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = { class: "ion-padding" }
const _hoisted_18 = { class: "text-base font-semibold leading-6 text-gray-500 dark:text-white" }
const _hoisted_19 = {
  key: 0,
  class: "font-bold text-white"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "mt-5 grid grid-cols-2 gap-5 sm:grid-cols-4" }
const _hoisted_22 = { class: "truncate text-lg font-medium text-gray-500" }
const _hoisted_23 = { class: "mt-1 text-xl font-semibold tracking-tight text-gray-900 text-center flex" }
const _hoisted_24 = {
  key: 0,
  class: "flex"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Los gesammelt", -1))
const _hoisted_26 = {
  key: 1,
  class: "flex"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "noch offen", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_TailwindDialog = _resolveComponent("TailwindDialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_confetti_bomb_animation = _resolveComponent("confetti-bomb-animation")!
  const _component_redeem_voucher_modal = _resolveComponent("redeem-voucher-modal")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!
  const _component_UserWallet = _resolveComponent("UserWallet")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              (!$setup.isIosPlatform())
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (!$setup.isIosPlatform())
                      ? (_openBlock(), _createBlock(_component_ion_img, {
                          key: 0,
                          slot: "start",
                          src: $setup.niceshopsLogo,
                          class: "h-8 pl-2 sm:pl-4"
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.treasureHuntTitle), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_ion_title, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_img, {
                          slot: "start",
                          src: $setup.niceshopsLogo,
                          class: "ion-float-left ion-align-items-start h-8 pl-2 sm:pl-4 pr-2"
                        }, null, 8, ["src"]),
                        _createTextVNode(_toDisplayString($setup.treasureHuntTitle), 1)
                      ]),
                      _: 1
                    })
                  ])),
              _withDirectives(_createVNode(_component_ion_buttons, {
                collapse: true,
                slot: "end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.refreshCollectedTickets())),
                    class: "buttonRefreshWallet"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $options.icons.refresh
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    class: "buttonShowChallengeDialog",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.setHasSeenTreasureHuntChallengeDialog(false)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $options.icons.helpOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, true]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_TransitionRoot, {
            as: "template",
            show: !$setup.hasSeenTreasureHuntChallengeDialog && $setup.isAuthenticated
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TailwindDialog, {
                as: "div",
                class: "relative z-10",
                onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.setHasSeenTreasureHuntChallengeDialog(true)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TransitionChild, {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_TransitionChild, {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DialogPanel, { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_DialogTitle, {
                                    as: "h3",
                                    class: "text-base font-semibold leading-6 text-gray-900"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.treasureHuntDialogTitle), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("p", {
                                      class: "text-sm text-gray-500",
                                      innerHTML: $setup.treasureHuntDialogDescription
                                    }, null, 8, _hoisted_8)
                                  ]),
                                  _createVNode(_component_ion_img, {
                                    class: "w-full h-full sm:-mt-4 sm:-mb-4",
                                    src: $setup.firstTimeTreasureHuntAnimation,
                                    alt: 'test'
                                  }, null, 8, ["src"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "inline-flex w-full justify-center rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.setHasSeenTreasureHuntChallengeDialog(true)))
                                }, _toDisplayString($setup.treasureHuntDialogBackButton), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"]),
          ($setup.hasAllTicketsCollected)
            ? (_openBlock(), _createBlock(_component_confetti_bomb_animation, { key: 0 }))
            : _createCommentVNode("", true),
          (!$setup.isCollectEasterEggDone && !$setup.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _createElementVNode("p", _hoisted_13, [
                  _createElementVNode("strong", {
                    class: "font-semibold",
                    innerHTML: $setup.easterEggBannerTitle
                  }, null, 8, _hoisted_14)
                ]),
                _createVNode(_component_redeem_voucher_modal, {
                  "voucher-type": $setup.treasureVoucherType,
                  "show-input-field": false,
                  title: "Osterei scannen",
                  "button-title": "Scan"
                }, null, 8, ["voucher-type"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_img, {
                  src: $setup.firstTimeTreasureHuntAnimation,
                  class: "h-20 p-1",
                  alt: "Meine Lose"
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString($setup.treasureWallet?.getPointsFormatted() ?? 0), 1),
                  _createTextVNode(" Lose gesammelt ")
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h3", _hoisted_18, [
                _createTextVNode("Heute gesammelt Lose "),
                _createElementVNode("span", {
                  class: _normalizeClass(['pl-2 inline-flex items-center rounded-full px-2 py-1 text-xs font-medium text-gray-800', $setup.collectedCount === 0 ? 'bg-gray-100' : '', $setup.collectedCount === 1 ? 'bg-yellow-400': '', $setup.collectedCount === 2 ? 'bg-orange-400' : '', $setup.collectedCount === 3 ? 'bg-green-300' : '', $setup.collectedCount === 4 ? 'bg-green-700' : ''])
                }, [
                  ($setup.collectedCount === 4)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Alle Lose gesammelt 🎉"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($setup.collectedCount) + " / 4", 1))
                ], 2)
              ]),
              _createElementVNode("dl", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.collectedTickets, (ticket) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: ticket.type,
                    class: "overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6"
                  }, [
                    _createElementVNode("dt", _hoisted_22, _toDisplayString(ticket.name), 1),
                    _createElementVNode("dd", _hoisted_23, [
                      (ticket.done)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                            _hoisted_25,
                            _createVNode(_component_CheckCircleIcon, {
                              class: "h-12 w-auto text-gr-primary self-center",
                              "aria-hidden": "true"
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_26, [
                            _hoisted_27,
                            _createVNode(_component_XCircleIcon, { class: "h-10 w-auto text-red-600 self-center" })
                          ]))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_component_UserWallet, {
            "wallet-type": $setup.treasureWalletType,
            "show-icon": false,
            "show-stats": false,
            "show-badge": false,
            onHandleRefresh: _cache[4] || (_cache[4] = ($event: any) => ($setup.refreshCollectedTickets())),
            class: "pb-12 sm:pb-0",
            "show-motivation-text": false
          }, null, 8, ["wallet-type"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}